import {Component} from '@angular/core';
import moment from 'moment';
import {RoutingService} from '@app/service/routing/routing.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  date: string;
  sitemapUrl: string;

  constructor(private routingService: RoutingService) {
    this.date = moment().format('YYYY');

    if (this.routingService.getHost().includes('localhost') ||
      this.routingService.getHost().includes('dev')) {
      this.sitemapUrl = 'https://dev-bff.carvry.com/v1/sitemap';
    } else {
      this.sitemapUrl = 'https://bff.carvry.com/v1/sitemap';
    }
  }
}
